import { FC, RefObject } from "react";

import { Box, Theme, useTheme } from "@mui/material";

export type CroppedDescriptionProps = {
  sanitizedDescription: string;
  contentRef: RefObject<HTMLDivElement | null>;
  maxHeight: { xs: string; md: string };
  gradientOverlayHeight: string;
  gradientOverlayColor: string;
  showGradient: boolean;
};

export const CroppedDescription: FC<CroppedDescriptionProps> = ({
  sanitizedDescription,
  contentRef,
  maxHeight,
  gradientOverlayHeight,
  gradientOverlayColor,
  showGradient,
}) => {
  const theme = useTheme<Theme>();

  return (
    <>
      {/* This content isn't shown, it's just used to calculate the height */}
      <Box
        ref={contentRef}
        aria-hidden="true"
        sx={{
          position: "absolute",
          maxHeight,
          overflow: "hidden",
          width: "100%",
          maxWidth: "100%",
          opacity: 0,
          pointerEvents: "none",
          ...theme.typography.body2,
          overflowWrap: "anywhere",
          ["& *"]: {
            maxWidth: "100%",
          },
          ["& p"]: {
            width: "auto !important",
            marginInline: "0 !important",
            marginTop: "0 !important",
            marginBottom: "0 !important",
          },
          ["& p:first-of-type"]: {
            marginTop: "0 !important",
          },
        }}
        dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
      />
      <Box
        position="relative"
        sx={{
          height: maxHeight,
          transition: "height 0.3s ease-in-out",
          overflow: "hidden",
          paddingTop: 0,
        }}
      >
        <Box
          sx={{
            ...theme.typography.body2,
            color: theme.palette.forms.text.moderate,
            maxWidth: "100%",
            overflowWrap: "anywhere",
            paddingTop: 0,
            marginTop: 0,
            ["& *"]: {
              maxWidth: "100%",
              color: "inherit !important",
            },
            ["& p"]: {
              width: "auto !important",
              marginInline: "0 !important",
              marginTop: "0 !important",
              marginBottom: "0 !important",
            },
            ["& p:first-of-type"]: {
              marginTop: "0 !important",
            },
          }}
          dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: gradientOverlayHeight,
            background: `linear-gradient(to bottom, transparent, ${gradientOverlayColor} 100%)`,
            pointerEvents: "none",
            opacity: showGradient ? 1 : 0,
            transition: "opacity 300ms linear",
          }}
        />
      </Box>
    </>
  );
};
